import { useEffect, useState } from "react";
import DynamicIcon from "./dynamic_icon";

function ValidatePassword({ value, isValid }: { value: string, isValid: (valid: boolean) => void }) {
  const [passwordEspecial, setPasswordEspecial] = useState(false)
  const [passwordLenght, setPasswordLenght] = useState(false)
  const [passwordNumber, setPasswordNumber] = useState(false)
  const [passwordUppercase, setPasswordUppercase] = useState(false)
  const [passwordLowercase, setPasswordLowercase] = useState(false)

  useEffect(() => {
    isValid(verificarSenha(value))
  }, [value])

  const checkPasswordLenght = (senha: string) => {
    if (senha.length < 6) {
      setPasswordLenght(false)
      return false
    }
    setPasswordLenght(true)
    return true
  }

  const checkPasswordEspecial = (senha: string) => {
    const caracteresEspeciais = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
    if (!caracteresEspeciais.test(senha)) {
      setPasswordEspecial(false)
      return false;
    }
    setPasswordEspecial(true)
    return true
  }

  const checkPasswordNumber = (senha: string) => {
    const numeros = /[0-9]/;
    if (!numeros.test(senha)) {
      setPasswordNumber(false)
      return false;
    }
    setPasswordNumber(true)
    return true
  }

  const checkPasswordUpperCase = (senha: string) => {
    const maiusculas = /[A-Z]/;
    if (!maiusculas.test(senha)) {
      setPasswordUppercase(false)
      return false;
    }
    setPasswordUppercase(true)
    return true
  }

  const checkPasswordLowercase = (senha: string) => {
    const minusculas = /[a-z]/;
    if (!minusculas.test(senha)) {
      setPasswordLowercase(false)
      return false;
    }
    setPasswordLowercase(true)
    return true
  }

  function verificarSenha(senha: string) {
    checkPasswordEspecial(senha)
    checkPasswordNumber(senha)
    checkPasswordLenght(senha)
    checkPasswordLowercase(senha)
    checkPasswordUpperCase(senha)
    const isValid = checkPasswordEspecial(senha) && checkPasswordNumber(senha) && checkPasswordLenght(senha) && checkPasswordLowercase(senha) && checkPasswordUpperCase(senha)
    return isValid
  }

  return (
    <div className="text-[13px] ml-2 mb-2">
      <div >
        <p className="font-bold">A senha deve conter:</p>
      </div>
      <div className="flex flex-row gap-1 items-center">
        <DynamicIcon nameIcon={passwordLenght ? "CheckRounded" : "CloseRounded"} size={12} className={passwordLenght ? "text-green-600" : "text-red-500"} />
        <p>Pelo menos 6 caracteres</p>
      </div>
      <div className="flex flex-row gap-1 items-center">
        <DynamicIcon nameIcon={passwordEspecial ? "CheckRounded" : "CloseRounded"} size={12} className={passwordEspecial ? "text-green-600" : "text-red-500"} />
        <p>Pelo menos um caractere especial (Exemplo: !@#$)</p>
      </div>
      <div className="flex flex-row gap-1 items-center">
        <DynamicIcon nameIcon={passwordNumber ? "CheckRounded" : "CloseRounded"} size={12} className={passwordNumber ? "text-green-600" : "text-red-500"} />
        <p>Pelo menos um número</p>
      </div>
      <div className="flex flex-row gap-1 items-center">
        <DynamicIcon nameIcon={passwordLowercase ? "CheckRounded" : "CloseRounded"} size={12} className={passwordLowercase ? "text-green-600" : "text-red-500"} />
        <p>Pelo menos uma letra minúscula</p>
      </div>
      <div className="flex flex-row gap-1 items-center">
        <DynamicIcon nameIcon={passwordUppercase ? "CheckRounded" : "CloseRounded"} size={12} className={passwordUppercase ? "text-green-600" : "text-red-500"} />
        <p>Pelo menos uma letra maiúscula</p>
      </div>
    </div>
  );
}

export default ValidatePassword;